import { ReactNode } from 'react';

import { Avatar } from '@mui/material';

import queryString from 'query-string';
import styled from 'styled-components';

const StyledProfileLabel = styled.div`
  &.profile-label {
    display: flex;
    gap: ${({ theme }) => theme.spacing(1)};
    align-items: center;

    .profile-gravatar {
      width: 33px;
      height: 33px;
    }
  }
`;

export interface BuildProfileLabelArgs {
  includeBetaMode?: boolean;
  firstName?: string;
  lastName?: string;
  profilePictureUrl?: string;
  isAdmin?: boolean;
  isUserReferralBeta?: boolean;
}
export const buildProfileLabel = (args: BuildProfileLabelArgs): ReactNode => {
  const { includeBetaMode, firstName, profilePictureUrl } = args;

  // Note: If we get back a missing image from Auth0 (Gravatar), we want to change the default image to be the first
  // letter of their name not first two
  const profilePictureParts = profilePictureUrl && profilePictureUrl.split('?');
  const profilePictureQueryParams: any = profilePictureParts && queryString.parse(profilePictureParts[1]);

  if (profilePictureQueryParams && profilePictureQueryParams.d) {
    const defaultImgUrl = profilePictureQueryParams.d;
    const imageRegex = /([a-zA-Z])([a-zA-Z])(.png)/;

    profilePictureQueryParams.d = defaultImgUrl.replace(imageRegex, '$1$3');
  }

  const pictureSrc =
    profilePictureParts && profilePictureParts[0]
      ? `${profilePictureParts[0]}?${queryString.stringify(profilePictureQueryParams)}`
      : 'fakebroken';

  const profilePicture = <Avatar className="profile-gravatar" alt={firstName} src={pictureSrc} />;

  return includeBetaMode ? (
    <StyledProfileLabel className="profile-label">
      {profilePicture}
      {firstName}
    </StyledProfileLabel>
  ) : (
    <StyledProfileLabel className="profile-label">
      {firstName}
      {profilePicture}
    </StyledProfileLabel>
  );
};
